import {
  MONITOR_SUPPLIER_LOAD,
  MONITOR_SUPPLIER_LOAD_SUCCESS,
  MONITOR_SUPPLIER_ERROR,
  MONITOR_SUPPLIER_CLEAN
} from "./actionTypes"

const initialState = {
  error: "",
  suppliers: [],
  loading: false,
  current:null
}

const supplierMonitor = (state = initialState, action) => {
  switch (action.type) {
    case MONITOR_SUPPLIER_LOAD:
      state = {
        ...state,
        suppliers: [],
        loading: true,
        error: "",
      }
      break
    case MONITOR_SUPPLIER_LOAD_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        suppliers: action.payload,
        current:action.payload.length===1?action.payload[0]:null
      }
      break
    case MONITOR_SUPPLIER_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        current:null
      }
      break

    case MONITOR_SUPPLIER_CLEAN:
      state = {
        ...state,
        loading: false,
        error: "",
      }
      break

  }
  return state
}

export default supplierMonitor
